export default __webpack_public_path__ + "static/media/logo-primary-col.c77fbab6.svg";